/* eslint-disable max-len */
import imageBackgroundHaloCleanMobile from '../static/images/service-product/halo-clean-mobile.svg'
import imageHaloCleanFirst from '../static/images/service-product/halo-clean/1.svg'
import imageHaloCleanSecond from '../static/images/service-product/halo-clean/2.svg'
import imageHaloCleanThird from '../static/images/service-product/halo-clean/3.svg'
import imageHaloCleanFourth from '../static/images/service-product/halo-clean/4.svg'

import imageBackgroundHaloFixMobile from '../static/images/service-product/halo-fix-mobile.svg'
import imageHaloFixFirst from '../static/images/service-product/halo-fix/1.svg'
import imageHaloFixSecond from '../static/images/service-product/halo-fix/2.svg'
import imageHaloFixThird from '../static/images/service-product/halo-fix/3.svg'
import imageHaloFixFourth from '../static/images/service-product/halo-fix/4.svg'
import imageHaloFixFifth from '../static/images/service-product/halo-fix/5.svg'
import imageHaloFixSixth from '../static/images/service-product/halo-fix/6.svg'
import imageHaloFixSeventh from '../static/images/service-product/halo-fix/7.svg'
import imageHaloFixEight from '../static/images/service-product/halo-fix/8.svg'
import imageHaloFixNinth from '../static/images/service-product/halo-fix/9.svg'
import imageHaloFixTen from '../static/images/service-product/halo-fix/10.svg'
import imageHaloFixEleven from '../static/images/service-product/halo-fix/11.svg'

import imageBackgroundHaloMassageMobile from '../static/images/service-product/halo-massage-mobile.svg'
import imageHaloMassageFirst from '../static/images/service-product/halo-massage/1.svg'
import imageHaloMassageSecond from '../static/images/service-product/halo-massage/2.svg'
import imageHaloMassageThird from '../static/images/service-product/halo-massage/3.svg'
import imageHaloMassageFourth from '../static/images/service-product/halo-massage/4.svg'
import imageHaloMassageFifth from '../static/images/service-product/halo-massage/5.svg'
import imageHaloMassageSixth from '../static/images/service-product/halo-massage/6.svg'
import imageHaloMassageSeventh from '../static/images/service-product/halo-massage/7.svg'
import imageHaloMassageEight from '../static/images/service-product/halo-massage/8.svg'
import imageHaloMassageNinth from '../static/images/service-product/halo-massage/9.svg'
import imageHaloMassageTen from '../static/images/service-product/halo-massage/10.svg'
import imageHaloMassageEleven from '../static/images/service-product/halo-massage/11.svg'
import imageHaloMassageTwelve from '../static/images/service-product/halo-massage/12.svg'
import imageHaloMassageThirteenth from '../static/images/service-product/halo-massage/13.svg'
import imageHaloMassageFourteenth from '../static/images/service-product/halo-massage/14.svg'

const serviceProductMobile = {
  HC: {
    imageBackground: imageBackgroundHaloCleanMobile,
    title: 'Pilihan Paket Halo Clean',
    products: [
      {
        id: 1,
        title: 'Paket Apartment/ Kost',
        subtitle: 'Paket bersih-bersih apartment atau kost',
        image: imageHaloCleanFirst
      },
      {
        id: 2,
        title: 'Paket Residensial',
        subtitle: 'Tidak perlu ribet bersih-bersih rumah Anda',
        image: imageHaloCleanSecond
      },
      {
        id: 3,
        title: 'Home Cleaning',
        subtitle: 'Layanan Home Cleaning paling tepat untuk rumah',
        image: imageHaloCleanThird
      },
      {
        id: 4,
        title: 'Office Cleaning',
        subtitle: 'Tetap jaga lingkungan kantor agar tetap bersih',
        image: imageHaloCleanFourth
      }
    ]
  },
  HF: {
    imageBackground: imageBackgroundHaloFixMobile,
    title: 'Pilihan Paket Halo Fix',
    products: [
      {
        id: 1,
        title: 'Cuci AC',
        subtitle:
          'Paket cuci AC mesin split aman, nyaman & lancar, AC menjadi bersih & dingin',
        image: imageHaloFixFirst
      },
      {
        id: 2,
        title: 'Cuci AC Inverter',
        subtitle: 'Pastikan ruanganmu tetap dingin dengan layanan ini',
        image: imageHaloFixSecond
      },
      {
        id: 3,
        title: 'Cuci AC Spesial',
        subtitle:
          'Paket cuci AC mesin split dengan teknologi terkini menjaga kebersihan dan kesehatan',
        image: imageHaloFixThird
      },
      {
        id: 4,
        title: 'Pengecekan AC',
        subtitle:
          'Jasa pengechekan masalah ac diiikuti dengan perbaikan atas persetujuan custumer',
        image: imageHaloFixFourth
      },
      {
        id: 5,
        title: 'Bongkar AC',
        subtitle: 'Pastikan ruanganmu tetap dingin dengan layanan ini',
        image: imageHaloFixFifth
      },
      {
        id: 6,
        title: 'Pasang AC',
        subtitle: 'Pasang AC dimana saja, pasang dengan aman, nyaman & lancar',
        image: imageHaloFixSixth
      },
      {
        id: 7,
        title: 'Bongkar Pasang AC Lokasi Sama',
        subtitle: 'Pasang AC diruanganmu dan pastikan AC kamu tetap dingin',
        image: imageHaloFixSeventh
      },
      {
        id: 8,
        title: 'Bongkar Pasang AC Lokasi Berbeda',
        subtitle: 'Pasang AC diruanganmu dan pastikan AC kamu tetap dingin',
        image: imageHaloFixEight
      },
      {
        id: 9,
        title: 'Freon',
        subtitle:
          'Layanan pengisian freon ac baik penambahan dan isi ulang setelah dilakukan pengchekan',
        image: imageHaloFixNinth
      },
      {
        id: 10,
        title: 'Service AC',
        subtitle:
          'Layanan service ac besar untuk perawatan  periodik untuk menjaga performance ac tetap prima',
        image: imageHaloFixTen
      },
      {
        id: 11,
        title: 'Perbaikan AC',
        subtitle:
          'Jasa Layanan perbaikan unit ac bermasalah setelah dilakukan pengchekan',
        image: imageHaloFixEleven
      }
    ]
  },
  HM: {
    imageBackground: imageBackgroundHaloMassageMobile,
    title: 'Pilihan Paket Pijat Panggilan',
    subtitle:
      'Berbagai layanan terapi massage mulai dari perawatan tubuh dan kecantikan',
    products: [
      {
        id: 1,
        title: 'Full Spa Body Massage',
        subtitle:
          'Pijatan Relaksasi dgn Teknik Pijatan dasar tradisional Spa dikombinasikan teknik pijat mode...',
        image: imageHaloMassageFirst
      },
      {
        id: 2,
        title: 'Serenity Spa Reflexolgy & Body Massage',
        subtitle:
          'Relaksasi pijat tradisional spa dengan tambahan teknik pijatan refleksi kaki, Menghilangkan pegal menenangkan...',
        image: imageHaloMassageSecond
      },
      {
        id: 3,
        title: 'Star Reflexology',
        subtitle:
          'Relaksasi yang fokus kepada penekanan pijat reflexi dikaki dan kombinasi dengan perengangan otot dan perawatan kaki...',
        image: imageHaloMassageThird
      },
      {
        id: 4,
        title: 'Full Spa Body Massage + Kerokan',
        subtitle:
          'Relaksasi Pijatan tradisional spa ditambah dengan tradisional treatment kerokan untuk mengatasi gejala masu...',
        image: imageHaloMassageFourth
      },
      {
        id: 5,
        title: 'Full Spa Body Massage + Luluran',
        subtitle:
          'Relaksasi Pijatan tradisional spa ditambah dengan treatment lulur/scrub untuk perawatan tubuh,mengangkat se...',
        image: imageHaloMassageFifth
      },
      {
        id: 6,
        title: 'Full Spa Body Massage Lulur + Masker Badan',
        subtitle:
          'Scrub untuk mengangkat sel kulit mato dan melembutkan kulit, ditambah masker untuk membuka pori-pori dan...',
        image: imageHaloMassageSixth
      },
      {
        id: 7,
        title: 'Full Spa Massage + Perawatan Lengkap',
        subtitle:
          'Mengembalikan suasana hati dan merileksasi kan tubuh, dengan pijat tradisional kami dan juga perawatan lulur...',
        image: imageHaloMassageSeventh
      },
      {
        id: 8,
        title: 'Hot Stone Spa Massage',
        subtitle:
          'Relaksasi pijatan klasik hydroterapi dengan menggunakan batu vulkanik,bermanfaat mengurangi stres dan...',
        image: imageHaloMassageEight
      },
      {
        id: 9,
        title: 'Massage + Totok wajah & Masker',
        subtitle:
          'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan juga fokus...',
        image: imageHaloMassageNinth
      },
      {
        id: 10,
        title: 'Full Spa Body Massage+ Creambath',
        subtitle:
          'Mengembalikan suasana hati dan menghilangkan stres dan ketegangan otot tubuh, dengan pijat tradisional...',
        image: imageHaloMassageTen
      },
      {
        id: 11,
        title: 'Full Spa Body Massage + Dry Cupping',
        subtitle:
          'Terapi pijat kesehatan untuk memperbaiki sistem Imun tubuh untuk mengatasi gejala masuk angin, dengan alternatif...',
        image: imageHaloMassageEleven
      },
      {
        id: 12,
        title: 'Sprain Massage',
        subtitle:
          'Perawatan relaksasi khusus untuk ibu hamil tidak diperuntukan yang mengalami kendala ataupun keluhan...',
        image: imageHaloMassageTwelve
      },
      {
        id: 13,
        title: 'Pregnancy Massage',
        subtitle:
          'Perawatan dan relaksasi pijatan tradisional untuk Ibu dan anak bayi pasca melahirkan (dilayani oleh teraphi...',
        image: imageHaloMassageThirteenth
      },
      {
        id: 14,
        title: 'Mom and Baby Massage',
        subtitle:
          'Perawatan dan relaxasi untuk meningkatkan kebahagiaan.meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot...',
        image: imageHaloMassageFourteenth
      }
    ]
  }
}

const serviceProductType = {
  HC: 'HC',
  HF: 'HF',
  HM: 'HM'
}

export default {
  serviceProductMobile,
  serviceProductType
}
